import { useHistory } from "react-router-dom";

import { randomColor } from "helpers/utils/randomColor";
import { getProjectName } from "helpers/projects";
import { Minus } from "@phosphor-icons/react";

function ProjectList({ category, projects, onRemove }) {
  const history = useHistory();
  return (
    <div className="space-y-2.5">
      <h1 className="text-xs ml-3 font-lato font-semibold leading-4 text-primary-gray-900">
        {category}
      </h1>
      <div className="grid grid-cols-2 gap-5">
        {projects.length > 0 &&
          projects.map((project) => {
            return (
              <div
                key={project?.id}
                className="flex flex-col items-center space-y-2.5"
              >
                <div
                  className="relative p-5 aspect-square flex flex-col items-center justify-center rounded-20px w-full bg-white"
                  style={{
                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.12)",
                  }}
                >
                  {onRemove && (
                    <Minus
                      className="absolute top-2 right-2"
                      color="red"
                      size={14}
                      onClick={() => onRemove(project)}
                    />
                  )}
                  {project?.image?.url ? (
                    <img
                      onClick={() => {
                        history.push(`/project/${project?.id}`);
                      }}
                      src={project?.image?.url}
                      className="rounded-md aspect-square object-contain"
                      alt=""
                    />
                  ) : (
                    <div
                      onClick={() => {
                        history.push(`/project/${project?.id}`);
                      }}
                      style={{ background: randomColor(Math.random()) }}
                      className="flex flex-row items-center justify-center h-24 w-24 flex-shrink-0 mx-auto rounded-full object-cover"
                    >
                      <p className="m-0 text-xl text-white">
                        {project?.title?.charAt(0).toUpperCase()}
                      </p>
                    </div>
                  )}
                </div>

                <p
                  onClick={() => {
                    history.push(`/project/${project?.id}`);
                  }}
                  className="text-xs font-lato text-black font-normal cursor-pointer break-words text-center"
                >
                  {getProjectName(project)}
                </p>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default ProjectList;

export function ProjectListLoader({}) {
  return (
    <div className="space-y-2.5">
      <p className="font-lato text-sm h-4 mx-7.5 w-20 rounded bg-primary-gray-200 animate-pulse font-normal text-primary-gray-600"></p>

      <div className="grid grid-cols-2 gap-5">
        {[1, 2, 3, 4].map((project) => {
          return (
            <div className="flex flex-col items-center space-y-2.5">
              <div
                className="p-5 aspect-square flex flex-col items-center justify-center rounded-20px w-full bg-white"
                style={{
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.12)",
                }}
              >
                <div
                  style={{ background: randomColor(Math.random()) }}
                  className="flex flex-row items-center justify-center h-24 w-24 flex-shrink-0 mx-auto rounded-full object-cover"
                >
                  <p className="m-0 text-xl text-white">U</p>
                </div>
              </div>

              <p className="font-lato text-sm h-4 rounded bg-primary-gray-200 w-7/12 animate-pulse font-normal text-primary-gray-600"></p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
